<div id="import-empres-popup" class="common-popup-block-doc">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>{{companyName}}</h2>
    </div>
    <form>
        <div class="popoup-content">
            <mat-progress-spinner *ngIf="isloading" class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
            <div  *ngIf="!isloading" class="">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                    <caption></caption>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Empresa </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="element.style"> {{element.name}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name1">
                        <th mat-header-cell *matHeaderCellDef> Identificador principal </th>
                        <td mat-cell *matCellDef="let element;let i= index">
                            <mat-form-field class="example-full-width">
                                <input type="text" matInput name="name1_{{i}}" [(ngModel)]="element.name1"
                                    [value]="element.name1" autocomplete="off">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name2">
                        <th mat-header-cell *matHeaderCellDef> Identificador secundario </th>
                        <td mat-cell *matCellDef="let element;let i= index">
                            <mat-form-field class="example-full-width">
                                <input type="text" matInput name="name2_{{i}}" [(ngModel)]="element.name2"
                                    [value]="element.name2" autocomplete="off">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name3">
                        <th mat-header-cell *matHeaderCellDef> Identificador terciario </th>
                        <td mat-cell *matCellDef="let element;let i= index">
                            <mat-form-field class="example-full-width">
                                <input type="text" matInput name="name3_{{i}}" [(ngModel)]="element.name3"
                                    [value]="element.name3" autocomplete="off">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'invalid' : row.invalid}"></tr>
                </table>


            </div>
        </div>
    </form>
    <div *ngIf="!isloading" class="popoup-footer">
        <button class="keep" (click)="saveEspecificarEmpresas()"><span
                class="mat-button-wrapper">Guardar</span></button>
        <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>